import React from "react";
import styles from "./Bob.module.css";
import background from "../../../Img/Main/background.png";
const Bob = () => {
  return (
    <div className={styles.container}>
      <div className={styles.mimo}>
        <div>
          <div>Bob</div>
          <div>Game Artist</div>
        </div>
      </div>
      <div className={styles.textBox}>
        <div className={styles.textList}>
          <div>
            우리는 자유로운 분위기에서 서로 머리를 맞대고 창의적인 아이디어를
            나눠요.
          </div>
          <br />
          <div>
            내가 만들고 싶은 게임을 기획하고 원하는 디자인으로 재미있게 작업할
            수 있어요.
          </div>
          <br />
          <div>
            부족한 것에 있어 겁먹을 필요 없이 서로서로 배우고 같이 성장하는
            재미를 찾아봐요!
          </div>
          <br />
        </div>
        <div>Bob/ Game Artist</div>
      </div>
    </div>
  );
};

export default Bob;
